import { render, staticRenderFns } from "./OwnersSmartTooltip.vue?vue&type=template&id=196bb01d&scoped=true&"
import script from "./OwnersSmartTooltip.vue?vue&type=script&lang=js&"
export * from "./OwnersSmartTooltip.vue?vue&type=script&lang=js&"
import style0 from "./OwnersSmartTooltip.vue?vue&type=style&index=0&id=196bb01d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196bb01d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBadge,VDataTable,VDivider})
